import { css } from 'lit';

export const postListStyles = css`
  :host {
    display: block;
  }

  .list-container {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .post-item {
    display: grid;
    grid-template-columns: 100px 1fr;
    gap: 1.25rem;
    align-items: first baseline;
    padding-bottom: 1.25rem;
    border-bottom: 1px dashed var(--border-subtle, #eeeee7);
    cursor: pointer;
    transition: background 0.15s ease;
  }

  .post-item:last-child {
    border-bottom: none;
  }

  .post-date {
    font-family: var(--font-mono, monospace);
    font-size: 0.82rem;
    color: var(--text-muted, #7c7c75);
  }

  .post-content h3 {
    font-family: var(--font-serif, serif);
    font-size: 1.15rem;
    font-weight: 600;
    color: var(--text-primary, #1a1a18);
    margin-bottom: 0.25rem;
    transition: color 0.15s ease;
  }

  .post-item:hover .post-content h3 {
    color: var(--accent-color, #245590);
  }

  .post-summary {
    font-size: 0.9rem;
    color: var(--text-secondary, #4a4a45);
    margin-bottom: 0.4rem;
    line-height: 1.5;
  }

  .meta-row {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    font-size: 0.78rem;
  }

  .read-time {
    font-family: var(--font-mono, monospace);
    color: var(--text-muted, #7c7c75);
  }

  .tag-chip {
    font-family: var(--font-mono, monospace);
    background-color: var(--bg-secondary, #f6f6f2);
    color: var(--text-secondary, #4a4a45);
    padding: 0.1rem 0.4rem;
    border-radius: 3px;
    font-size: 0.72rem;
  }

  @media (max-width: 600px) {
    .post-item {
      grid-template-columns: 1fr;
      gap: 0.4rem;
    }
  }
`;
